<template>
  <GenericDialog :activator="activator" @close="() => emit('close')">
    <v-card-title> Edit favourite location </v-card-title>
    <FavLocationForm @close="() => emit('close')" :initialValue="favLocation" />
  </GenericDialog>
</template>
<script lang="ts" setup>
import GenericDialog from '../dialog-wrappers/GenericDialog.vue'
import FavLocationForm from './FavLocationForm.vue'
import FavouriteLocation from '@/classes/favouriteLocation'

const { activator, favLocation } = defineProps<{
  activator: boolean
  favLocation?: FavouriteLocation | undefined
}>()
const emit = defineEmits<{ (e: 'close'): void }>()
</script>
